import SelectedVehicleCard from './SelectedVehicleCard';

export default SelectedVehicleCard;
